<template>
  <div v-if="!weeklyRatingPresenter.hasData.value" class="w-full h-full flex justify-center items-center">
    {{ $t('message.noData') }}
  </div>
  <VueApexCharts
    v-else
    height="100%"
    :options="weeklyRatingPresenter.chartOptions.value"
    :series="weeklyRatingPresenter.chartSeries.value"
    type="area"
  />
</template>

<script lang="ts">
import { defineComponent, SetupContext } from 'vue'

import VueApexCharts from 'vue3-apexcharts'

import { dashboardTargetColor, weeklyRatingChartColor } from '@/domain/value_objects/color/ColorList'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useDashboardModalStatePresenter } from '@/presentation/composables/dashboard/useDashboardModalStatePresenter'
import { useWeeklyRatingPresenter } from '@/presentation/composables/dashboard/useWeeklyRatingPresenter'

export default defineComponent({
  components: { VueApexCharts },
  setup(props, ctx: SetupContext) {
    const dashboardModalStatePresenter = useDashboardModalStatePresenter()
    const weeklyRatingPresenter = useWeeklyRatingPresenter()
    const { isLightMode, displayLanguage } = useConfigStatePresenter()

    const initChart = () => {
      weeklyRatingPresenter.initChart(
        dashboardModalStatePresenter.dashboardUserList.value,
        weeklyRatingChartColor,
        dashboardTargetColor,
        displayLanguage.value,
        isLightMode()
      )
    }

    return {
      initChart,
      weeklyRatingPresenter
    }
  }
})
</script>

<style lang="postcss" scoped></style>
